import { Component, ElementRef, HostListener, Input, forwardRef, inject, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment, { Moment } from 'moment';
import 'moment/locale/pt-br';
import { CalendarioComponent } from '../calendario/calendario.component';

@Component({
  selector: 'app-campo-data',
  standalone: true,
  imports: [CalendarioComponent],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CampoDataComponent), multi: true },
  ],
  templateUrl: './campo-data.component.html',
  styleUrl: './campo-data.component.css'
})
export class CampoDataComponent implements ControlValueAccessor {
  @Input() label = 'Data';
  @Input() icone = './assets/icones/redesign/inputs/input-date-calendar.svg';
  @Input() dataMinima: Moment | null = null;
  @Input() erro = '';
  @Input() disabled = false;

  aberto = signal(false);
  valor: Moment | null = null;
  tocado = false;

  private readonly elementRef = inject(ElementRef);
  private onChange: (value: Moment | null) => void = () => { /* */ };
  private onTouched: () => void = () => { /**/ };

  @HostListener('document:click', ['$event'])
  aoClicarFora(event: MouseEvent) {
    if (!event.composedPath().includes(this.elementRef.nativeElement)) {
      this.fechar();
    }
  }

  get valorFormatado(): string {
    return this.valor ? this.valor.format('DD/MM/YYYY') : '';
  }

  writeValue(value: Moment | null): void {
    this.valor = value ?? null;
  }

  registerOnChange(fn: (value: Moment | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  alternar() {
    if (this.disabled) {
      return;
    }
    this.aberto.update(v => !v);
    if (!this.aberto()) {
      this.aoTocar();
    }
  }

  aoSelecionar(valor: Moment) {
    this.valor = valor;
    this.onChange(valor);
    this.fechar();
  }

  private fechar() {
    if (this.aberto()) {
      this.aberto.set(false);
      this.aoTocar();
    }
  }

  private aoTocar() {
    this.tocado = true;
    this.onTouched();
  }
}
